import { Button, Container, Grid, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { useEffect } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import img from '../../../assets/img/quote-submitted.jpg'
import FormContainer from '../../Form/FormContainer'


const QuoteSubmitted = () => {
  const history = useHistory()

  const userLogin = useSelector((state: RootStateOrAny) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (!userInfo) {
      history.push(`/login?redirect=${window.location.pathname}`)
    }
  }, [history, userInfo])

  return (
    <Container style={{ minHeight: 'calc(100vh - 120px)' }}>
      <div className="flex flex-end m-t-40 m-b-25">
        <div>
          <IconButton onClick={() => history.push('/myquality/dashboard')}>
            <Close />
          </IconButton>
        </div>
      </div>

      <FormContainer>
        <Grid container>
          <Grid item md={2} xs={12}></Grid>

          <Grid item md={8} xs={12}>
            <h5 className="m-t-100">Your quote request has been submitted!</h5>
            <p>A Hexagon application engineer will be in touch shortly. </p>

            <img className="m-b-40 m-t-20" src={img} alt="Quote submitted" />

            <div className="flex flex-end">
              <Button
                className="m-b-100"
                variant="contained"
                color="primary"
                onClick={() => history.push('/myquality/dashboard')}
              >
                Go to projects page
              </Button>
            </div>
          </Grid>
        </Grid>
      </FormContainer>
    </Container>
  )
}

export default QuoteSubmitted
